module.exports = __webpack_public_path__ + "img/sword-water-02.b5daa6b7.png";